import {request} from "@/backend/backend_util.js";

export const checkinBackend = {
    commentOnCheckin: request('POST', `/checkins/comment`),
    commentOnSelfMissing: request('POST', `/checkins/comment/self-missing`),
    refreshComments: (id: string) => request('GET', `/checkins/${id}/comments`),
}
